import { useState } from "react";
import timeAgo from "../utils/timeAgo";

const ICON = {
  friend: "🤝",
  wishlist: "🔖",
  memo_like: "❤️",
  reply: "💬",
  same_book: "📖",
};

/* 알림 한 줄. 종류가 늘어 삼항으로 잇기 어려워졌다. */
function line(n) {
  const who = <span className="notif-from">{n.fromUserName}</span>;
  const book = <span className="notif-book"> {n.bookTitle || "책"}</span>;
  switch (n.type) {
    case "friend":
      return <>{who}님이 이웃 행성으로 추가했어요</>;
    case "memo_like":
      return <>{who}님이{book}에 남긴 이야기에 좋아요를 눌렀어요</>;
    case "reply":
      return <>{who}님이{book}에 남긴 이야기에 댓글을 달았어요</>;
    case "same_book":
      return <>{who}님도{book}을(를) 담았어요</>;
    case "wishlist":
    default:
      return <>{who}님이{book}을(를) 읽고 싶은 책에 담았어요</>;
  }
}

const NotificationBell = ({ notifications, onMarkNotificationsRead, onClearNotifications }) => {
  const [showNotifs, setShowNotifs] = useState(false);
  const unreadCount = notifications.filter(n => !n.read).length;

  return (
    <div className="notif-wrapper">
      <button className="btn-notif" onClick={() => { setShowNotifs(!showNotifs); if (!showNotifs && unreadCount > 0 && onMarkNotificationsRead) onMarkNotificationsRead(); }} title="알림">
        🔔
        {unreadCount > 0 && <span className="notif-badge">{unreadCount}</span>}
      </button>
      {showNotifs && (
        <div className="notif-dropdown">
          <div className="notif-dropdown-header">
            알림
            {/* 알림은 쌓이기만 하고 지울 방법이 없었다.
                되돌릴 수 없는 동작이라 한 번 묻는다. */}
            {notifications.length > 0 && onClearNotifications && (
              <button
                className="notif-clear"
                onClick={(e) => {
                  e.stopPropagation();
                  if (window.confirm(`알림 ${notifications.length}개를 모두 지울까요?`)) {
                    onClearNotifications();
                  }
                }}
              >전체 삭제</button>
            )}
          </div>
          {notifications.length === 0 ? (
            <div className="notif-empty">알림이 없어요</div>
          ) : (
            /* 최신이 위다. 목록은 이미 최신순으로 오는데 여기서 뒤집고
               있어서, 열 개만 자르면 가장 오래된 열 개가 보였다. */
            notifications.slice(0, 10).map((n, i) => (
              <div key={n.id ?? i} className={`notif-item${n.read ? "" : " unread"}`}>
                <span>{ICON[n.type] || "🔖"}</span>
                <div>
                  {line(n)}
                  {/* 언제 온 알림인지. 일주일이 넘으면 날짜로 바뀐다 */}
                  {n.createdAt && <span className="notif-when">{timeAgo(n.createdAt)}</span>}
                </div>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default NotificationBell;
